export function TrustBar() {
  const avatars = [
    'https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=100',
    'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=100',
    'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=100',
    'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=100',
    'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=100',
  ];

  return (
    <section className="py-6 px-4 md:px-8 bg-brand-40">
      <div className="max-w-[1216px] mx-auto flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
        <div className="flex -space-x-3">
          {avatars.map((avatar, i) => (
            <div
              key={i}
              className="w-10 h-10 rounded-full border-2 border-white overflow-hidden"
            >
              <img
                src={avatar}
                alt={`User ${i + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
        <p className="text-white font-semibold text-lg">
          Trusted By <span className="text-brand-10">1,000+</span> Worldwide
        </p>
      </div>
    </section>
  );
}
